/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* ===========================================================================
   Goodbean - Lager-Hinweis (stock-note): Text je nach Produkttyp
   -------------------------------------------------------------
   Kaffee-Produkte (Produkttyp "Coffee") zeigen einen eigenen Text,
   alle anderen den Standard-Text.  (Die OPTIK liegt in assets/gb-global.css.)
   >>> TEXTE HIER AENDERN: <<<
=========================================================================== */
window.GB_STOCK_NOTE = {
  // Text fuer normale Produkte (Zubehoer etc.)
  standard: 'Auf Lager',
  // Text fuer Kaffee-Produkte (Produkttyp "Coffee")
  kaffee: 'Ist vorrätig oder wird frisch für dich geröstet'
};

(function () {
  // Nur auf Produktseiten aktiv
  if (location.pathname.indexOf('/products/') < 0) return;

  function desired() {
    var t = '';
    try { t = ShopifyAnalytics.meta.product.type || ''; } catch (e) {}
    return (t === 'Coffee') ? window.GB_STOCK_NOTE.kaffee : window.GB_STOCK_NOTE.standard;
  }

  function swap() {
    var el = document.querySelector('.product-single__box__block--inventory_notice .stock-note--in-stock:not(.stock-note--low) .stock-note__text');
    if (!el) return false;
    var txt = desired();
    if (txt && el.textContent.trim() !== txt) el.textContent = txt;
    return true;
  }

  function start() {
    var n = 0;
    var iv = setInterval(function () { swap(); if (n++ > 40) clearInterval(iv); }, 250);
    document.addEventListener('change', function () { setTimeout(swap, 80); });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();